module.exports = __webpack_public_path__ + "static/media/404NotFound.7e1edfef.jpg";